import { FaLinkedin, FaSquareEnvelope, FaSquareXTwitter } from 'react-icons/fa6'
import { IconType } from 'react-icons/lib'
import Constants from 'common/utils/constants'

export interface SocialMediaLink {
  href: string
  Icon: IconType
}

export const defaultSocialMediaLinks = [
  { href: 'https://uk.linkedin.com/company/legal-utopia', Icon: FaLinkedin },
  { href: 'https://x.com/ailegalutopia', Icon: FaSquareXTwitter },
  {
    href: `mailto:${Constants.supportEmail}`,
    Icon: FaSquareEnvelope,
  },
]
